import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, shareReplay} from "rxjs";
import {Feature, GetEnabledFeaturesRequest} from "@app/_models/api";
import {AuthService} from "@app/_services/auth.service";
import {ApiService} from "@app/_services/api.service";

const CACHE_SIZE = 1;

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {
    private _enabledFeatures = new BehaviorSubject<Feature[] | null>(null);

    constructor(private authService: AuthService, private apiService: ApiService) {
    }

    enabledFeatures(): Observable<Feature[] | null> {
        return this._enabledFeatures.asObservable();
    }

    setEnabledFeatures() {
        const body: GetEnabledFeaturesRequest = {
            email: this.authService.userValue?.email!,
        };

        this.apiService.getEnabledFeatures(body).pipe(shareReplay(CACHE_SIZE)).subscribe(
            (response: Feature[]) => this._enabledFeatures.next(response)
        );
    }
}
